"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompositeFilterDescriptor = void 0;
var utils_1 = require("../utils");
// tslint:enable:max-line-length
/**
 * @hidden
 * Type guard for `CompositeFilterDescriptor`.
 */
var isCompositeFilterDescriptor = function (source) {
    return (0, utils_1.isPresent)(source.filters);
};
exports.isCompositeFilterDescriptor = isCompositeFilterDescriptor;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-data-query@1.7.1/~/@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface.js
// module id = 78
// module chunks = 0